module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section_form",
    attrs: {
      "id": "form"
    }
  }, [_c('div', {
    staticClass: "container bis center-text"
  }, [_c('div', {
    directives: [{
      name: "lang",
      rawName: "v-lang.rejoignez-maintenant",
      modifiers: {
        "rejoignez-maintenant": true
      }
    }]
  }), _vm._v(" "), _c('form', [_c('div', {
    directives: [{
      name: "lang",
      rawName: "v-lang.info-contact",
      modifiers: {
        "info-contact": true
      }
    }],
    staticClass: "st_white"
  }), _vm._v(" "), _c('FormInput', {
    attrs: {
      "value": _vm.formData.Nom,
      "action": _vm.updateNom,
      "placeholder": 'nom',
      "isRequired": ""
    }
  }), _vm._v(" "), _c('FormInput', {
    attrs: {
      "value": _vm.formData.Prenom,
      "action": _vm.updatePrenom,
      "placeholder": 'prenom',
      "isRequired": ""
    }
  }), _vm._v(" "), _c('FormInput', {
    attrs: {
      "value": _vm.formData.Telephone,
      "action": _vm.updateTelephone,
      "placeholder": 'telephone',
      "isRequired": ""
    }
  }), _vm._v(" "), _c('FormInput', {
    attrs: {
      "value": _vm.formData.Email,
      "action": _vm.updateEmail,
      "placeholder": 'email',
      "isRequired": "",
      "isEmail": ""
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "lang",
      rawName: "v-lang.info-societe",
      modifiers: {
        "info-societe": true
      }
    }],
    staticClass: "st_white"
  }), _vm._v(" "), _c('FormInput', {
    attrs: {
      "value": _vm.formData.RaisonSociale,
      "action": _vm.updateRaisonSociale,
      "placeholder": 'raison-sociale',
      "isRequired": ""
    }
  }), _vm._v(" "), _c('FormInput', {
    attrs: {
      "value": _vm.formData.Adresse,
      "action": _vm.updateAdresse,
      "placeholder": 'adresse',
      "isRequired": ""
    }
  }), _vm._v(" "), _c('FormInput', {
    attrs: {
      "value": _vm.formData.Cp,
      "action": _vm.updateCodePostal,
      "placeholder": 'code-postal',
      "isRequired": ""
    }
  }), _vm._v(" "), _c('FormInput', {
    attrs: {
      "value": _vm.formData.Ville,
      "action": _vm.updateVille,
      "placeholder": 'ville',
      "isRequired": ""
    }
  }), _vm._v(" "), _c('FormSelect', {
    attrs: {
      "data": _vm.listePays,
      "value": _vm.formData.IsoPays,
      "action": _vm.updatePays,
      "placeholder": 'pays',
      "isRequired": ""
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "lang",
      rawName: "v-lang.domaine-activite",
      modifiers: {
        "domaine-activite": true
      }
    }],
    staticClass: "st_white"
  }), _vm._v(" "), _c('FormCheckbox', {
    attrs: {
      "data": _vm.listeCategories,
      "value": _vm.formData.Categories,
      "action": _vm.updateCategories,
      "inline": "",
      "placeholder": 'categories-produit',
      "isRequired": "",
      "isTrad": ""
    }
  }), _vm._v(" "), _c('FormTextarea', {
    attrs: {
      "value": _vm.formData.Marques,
      "action": _vm.updateMarques,
      "placeholder": 'marques-concernees'
    }
  }), _vm._v(" "), _c('FormSelect', {
    attrs: {
      "data": _vm.listePays,
      "value": _vm.formData.IsoPaysExpedition,
      "action": _vm.updatePaysExpedition,
      "placeholder": 'pays-expedition',
      "isRequired": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ligne2"
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "lang",
      rawName: "v-lang.envoyer",
      modifiers: {
        "envoyer": true
      }
    }],
    staticClass: "btn bis form btn-large",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.sendForm
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a66d386c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/Formulaire.vue
// module id = 59
// module chunks = 0